import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import CustomButton from "../../../../components/lib/customButton";
import EmployeeRegisterForm from "../../forms/employeeRegisterForm";
import { formatCurrency } from "../../../../utils/CurrencyUtils";
import Stepper from "../../../../components/lib/stepperHeader";

const STEP = {
    EMPLOYEE: 0,
    SUMMARY: 1,
};

const steps = [
    { key: STEP.EMPLOYEE, label: "Colaborador" },
    { key: STEP.SUMMARY, label: "Resumo" },
];

const Spinner = () => (
    <div className="w-4 h-4 border-2 border-white border-t-transemployee rounded-full animate-spin" />
);

const EmployeeRegisterStepper = ({ onFinish, onCancel, onDirty, isSubmitting }) => {
    const [step, setStep] = useState(STEP.EMPLOYEE);
    const [employeeDraft, setParentDraft] = useState(null);

    const submitActiveForm = () => {
        document.querySelector("form[data-step-form]")?.requestSubmit();
    };

    const goBack = () => {
        if (step === STEP.EMPLOYEE) return onCancel();
        setStep(step - 1);
    };

    return (
        <div className="flex flex-col gap-6">
            <Stepper
                steps={steps}
                currentStep={step}
            />

            {/* CONTENT */}
            <div className="min-h-[360px]">
                <AnimatePresence mode="wait">
                    <motion.div key={step} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.2 }}>

                        {/* STEP 1 */}
                        {step === STEP.EMPLOYEE && (
                            <EmployeeRegisterForm
                                onDirty={onDirty}
                                onSubmit={(data) => {
                                    setParentDraft(data);
                                    setStep(STEP.SUMMARY);
                                }}
                            />
                        )}

                        {/* STEP 2 */}
                        {step === STEP.SUMMARY && (
                            <div className="space-y-4">
                                <h3 className="font-semibold">Resumo</h3>

                                <div className="border rounded p-4 text-sm text-start space-y-1">
                                    <div>
                                        <p><strong>Colaborador:</strong> {employeeDraft.name}</p>
                                        <p><strong>Email:</strong> {employeeDraft?.email}</p>
                                        <p><strong>Telefone:</strong> {employeeDraft?.phone_number}</p>
                                        <p><strong>Endereço:</strong> {employeeDraft.address}</p>
                                        <div className="flex justify-between items-center">
                                            <p><strong>Valor de Emergência:</strong> {formatCurrency(employeeDraft?.emergency_value)}</p>
                                            <p><strong>Limite de Gastos:</strong> {formatCurrency(employeeDraft?.spend_limit)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </motion.div>
                </AnimatePresence>
            </div>

            {/* FOOTER */}
            <div className="flex justify-between">
                <CustomButton
                    buttonType={step === STEP.EMPLOYEE ? "cancel" : "confirmLater"}
                    text={step === STEP.EMPLOYEE ? "Cancelar" : "Voltar"}
                    showIcon={false}
                    onClick={goBack}
                />


                {step === STEP.EMPLOYEE && (
                    <CustomButton buttonType="confirm" text="Avançar" showIcon={false}
                        onClick={submitActiveForm} />
                )}

                {step === STEP.SUMMARY && (
                    <CustomButton
                        buttonType="confirm"
                        text={
                            isSubmitting ? (
                                <>
                                    <span className="ml-2">Processando</span>
                                    <Spinner />
                                </>
                            ) : (
                                "Concluir"
                            )
                        }
                        showIcon={false}
                        disabled={isSubmitting}
                        onClick={() =>
                            onFinish({
                                employee: employeeDraft,
                            })
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default EmployeeRegisterStepper;
